<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>绑定手机</span>
      <img :src="fanhuiIcon" :class="$style.fanhui" @click="back" v-if="config_bind_force !== 1" />
    </header>
    <main>
      <p v-if="bindHintText">{{ bindHintText }}</p>
      <p v-else>友情提示：为了您的账号安全，请绑定手机号</p>
      <div :class="$style.content">
        <div :class="$style.inputWrap">
          <img :src="shoujihaoIcon" :class="$style.leftIcon" />
          <input type="number" placeholder="请输入手机号" v-model.trim="phone" />
        </div>
        <div :class="[$style.inputWrap, $style.code]">
          <img :src="yanzhengmaIcon" :class="$style.leftIcon" />
          <input type="number" placeholder="请输入验证码" v-model.trim="code" />
          <span :class="$style.getCode" v-if="codeShow" @click="getCode">获取</span>
          <span :class="$style.getCode" v-else>{{ count }}</span>
        </div>
      </div>
      <button :class="$style.submitBtn" @click="bindPhone">确定</button>
    </main>
  </div>
</template>

<script>
import isFullScreen from '@/libs/business/fullScreen'
import { mapState, mapMutations } from 'vuex';
import { regexpVerify } from '@/libs/business/account';
import { getSmsCode, bindTel } from '@/api/user'
import { batchSetStorage } from '@/libs/utils';

export default {
  name: "WechatBindPhone",
  data() {
    return {
      fullScreen: '',
      phone: '',
      code: '',
      codeShow: true,
      count: '',
      timer: null,
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/fanhui.png`,
      shoujihaoIcon: `${this.$cdnLink}/wanXin/orangeTheme/shoujihao.png`,
      yanzhengmaIcon: `${this.$cdnLink}/wanXin/orangeTheme/yanzhengma.png`
    };
  },
  props: ['config_bind_force', 'bindHintText'],
  created() {
    this.fullScreen = isFullScreen();
  },
  computed: {
    ...mapState({
      userState: state => state.user
    })
  },
  methods: {
    ...mapMutations({
      showLoading: 'global/showLoading',
      changeUserState: 'user/CHANGE_STATE'
    }),
    back() {
      if (this.config_bind_force === 1) {
        this.$toast('必须绑定手机号才能继续游戏');
        return;
      }
      this.$emit('close')
    },
    async getCode() {
      await regexpVerify({ phone: this.phone }, [
        { key: 'phone', hint: '请输入正确的手机号', type: 'phone' }
      ]);
      const { appkey } = this.userState
      this.setTimer()
      try {
        await getSmsCode({
          jh_app_id: appkey,
          tel_num: this.phone,
          type: 'bind'
        })
        this.$toast('发送成功')
      } catch (error) {
        this.clearTimer()
      }
    },
    setTimer() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    clearTimer() {
      this.codeShow = true;
      this.count = '';
      clearInterval(this.timer);
      this.timer = null;
    },
    async bindPhone() {
      await regexpVerify({ phone: this.phone, code: this.code }, [
        { key: 'code', hint: '请输入验证码' },
        { key: 'phone', hint: '请输入正确的手机号', type: 'phone' },
      ]);
      const { username, user_id, access_token, appkey } = this.userState
      let params = {
        tel_num: this.phone,
        code: this.code,
        user_name: username,
        user_id: user_id,
        access_token: access_token,
        appkey: appkey
      }
      this.showLoading();
      const r = await bindTel(params)
      this.$toast('绑定成功')
      this.changeUserState({ tel_num: this.phone, tel_status: 1 })
      // 原生包添加缓存
      batchSetStorage({ tel_status: 1, tel_num: this.phone })
      this.phone = '';
      this.code = '';
      this.$emit('close', true);
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../assets/css/common.scss";

.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding: 0.3rem 0.2rem;
    overflow-y: auto;
    > p {
      padding: 0 .3rem;
      line-height: .26rem;
    }
    .inputWrap {
      @include common-inputWrap();
      position: relative;
      z-index: 10;
      margin: 0.2rem auto;
      font-size: 0.3rem;
      > input {
        width: 3.4rem;
      }
      &.code {
        margin-bottom: 0.34rem;
        > input {
          width: 2.2rem;
        }
        .getCode {
          display: flex;
          align-items: center;
          color: $primary-color;
          border-left: 1px solid $primary-color;
          padding-left: 0.1rem;
          width: 1.2rem;
          height: 0.5rem;
          justify-content: center;
          font-size: $font-nm-1;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
  }
  &.fullScreen {
    @include full-screen-window();
    z-index: 1000;
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 15px 10px;
      overflow-y: auto;
      > p {
        padding: 0 15px;
        line-height: 13px;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        position: relative;
        z-index: 10;
        margin: 10px auto;
        font-size: 15px;
        > input {
          width: 170px;
        }
        &.code {
          margin-bottom: 17px;
          > input {
            width: 110px;
          }
          .getCode {
            display: flex;
            align-items: center;
            color: $primary-color;
            border-left: 1px solid $primary-color;
            padding-left: 5px;
            width: 60px;
            height: 25px;
            justify-content: center;
            font-size: $font-nm;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
    }
  }
}
</style>
